import React from "react";
import { Paper } from "@material-ui/core";

const Unauthorized = () => {
  return (
    <Paper elevation={3} style={{ height: "100%" }}>
      <div className="col-md-4 pt-5 mx-auto">
        <h3>Unauthorized</h3>
        <span>You shouldn't be here</span>
      </div>
    </Paper>
  );
};

export default Unauthorized;
